import styled, { css } from 'styled-components';

export const Badge = styled.span`
  ${({ theme }) => css`
    display: inline-block;
    padding: ${theme.v3.spacing.quarck} ${theme.v3.spacing.xxxs};
    background: ${theme.v3.colors.brand.snappyOrange[95]};
    color: ${theme.v3.colors.brand.snappyOrange[50]};
    border-radius: 9999px;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    white-space: nowrap;
  `}
`;
